import React from 'react';

import { Page } from 'components/modules/AutoruLayout/Page/Page';
import { PageContent } from 'components/modules/AutoruLayout/PageContent/PageContent';

import { Stepper } from '../Stepper/Stepper';

export const Underwriting = () => {
  return (
    <Page aside={<Stepper />}>
      <PageContent
        title="Андеррайтинг"
        description="Приложите фотографии и&nbsp;файлы, которые подтверждают предоставленную информацию, напишите комментарий с&nbsp;пояснениями в&nbsp;ответ на&nbsp;сообщение андеррайтера"
      ></PageContent>
    </Page>
  );
};
